var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAnnouncements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 46,
    viewBox: "0 0 54 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5003 0.5V5.39L3.69027 13.7C2.64027 13.88 1.71027 14.45 1.02027 15.26C0.330269 16.07 -0.0297306 17.12 0.000269356 18.2V27.95C0.000269356 29.03 0.330269 30.05 1.02027 30.89C1.71027 31.7 2.64027 32.27 3.69027 32.45L9.00027 33.23V40.97C9.00027 42.17 9.48027 43.31 10.3203 44.15C11.1603 44.99 12.3003 45.47 13.5003 45.47H31.5003C32.7003 45.47 33.8403 44.99 34.6803 44.15C35.5203 43.31 36.0003 42.17 36.0003 40.97V38.12L49.5003 40.58V45.47H54.0003V0.5H49.5003ZM31.5003 41H13.5003V34.1L31.5003 37.37V41.03V41ZM4.50027 27.89V18.11L49.5003 9.95V36.05L4.50027 27.89Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnnouncements);
export default __webpack_public_path__ + "static/media/ic-announcements.2301e3a8551493a851816622fc46a3c2.svg";
export { ForwardRef as ReactComponent };